import { useState as a, useRef as c, useEffect as f, useCallback as i, useMemo as d } from "react";
import { useParams as w } from "react-router-dom";
async function g(e, r, n) {
  return [...e].reduce((t, s) => {
    const o = t.pop();
    return o ? [...t, o, o + s] : [...t, s];
  }, []).map(
    (t) => () => new Promise((s) => {
      setTimeout(() => s(t), n);
    }).then(r)
  ).reduce((t, s) => t.then(s), Promise.resolve());
}
function T() {
  const [e, r] = a(""), [n, t] = a(!1);
  async function s({
    text: o,
    characterAnimationDelay: u
  }) {
    t(!0), await g(o, r, u), t(!1);
  }
  return {
    displayedText: e,
    animate: s,
    isAnimating: n
  };
}
function h(e) {
  const { [e]: r } = w();
  if (!r)
    throw Error(`URL parameter ${e} is not defined, returned as "${r}"`);
  return r;
}
function v(e) {
  const [r, n] = a(!1), t = c(void 0), s = c(e);
  f(() => {
    s.current = e;
  }, [e]);
  const o = i(
    () => window.clearInterval(t.current),
    []
  ), u = i((l) => {
    if (Number.isInteger(l))
      n(!0), t.current = window.setInterval(() => {
        s.current();
      }, l);
    else
      throw n(!1), new Error("Interval must be an integer");
  }, []), m = i(() => {
    n(!1), o();
  }, [o]);
  return f(() => o, [o]), { poll: u, stop: m, isPolling: r };
}
function P(e = !1) {
  const [r, n] = a(e), t = () => n((u) => !u), s = () => n(!0), o = () => n(!1);
  return d(() => ({ value: r, toggle: t, on: s, off: o }), [r]);
}
function A(e = !1) {
  const [r, n] = a(e);
  function t() {
    n((s) => !s);
  }
  return [r, t];
}
function x() {
  const e = c(null);
  return i(
    (n, t) => (e.current && window.cancelAnimationFrame(e.current), e.current = window.requestAnimationFrame(
      () => n == null ? void 0 : n.scrollIntoView({
        behavior: "smooth",
        ...t
      })
    ), e.current),
    []
  );
}
export {
  T as useAnimateText,
  h as useDefinedParam,
  v as usePolling,
  x as useScrollToElement,
  P as useSwitch,
  A as useToggle
};
